<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <modal-select modal="dealers-modal" v-validate="'required'" name="dealer_id" :readonly="false" :item-id="item.dealer_id" :item-name="item.dealer_id?item.dealer.data.name:''" v-on:select-item="selectDealer"  :state="validateState('dealer_id')" placeholder="Distribuidor" label="Distribuidor" ></modal-select>
          <modal-select modal="operators-modal"  v-validate="'required'"name="operator_id" :readonly="false" :item-id="item.operator_id" :item-name="item.operator_id?item.operator.data.name:''" v-on:select-item="selectOperator"  :state="validateState('operator_id')" placeholder="Operador" label="Operador" ></modal-select>
          <b-form-group label="NIF">
            <b-form-input type="text" name="nif" v-model="item.nif" placeholder="NIF"  v-validate="'required'" :state="validateState('nif')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('nif') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Codle">
            <b-form-input type="text" name="codle" v-model="item.codle" placeholder="Codle"  v-validate="'required'" :state="validateState('codle')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('codle') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-row>
            <b-col md="3">
              <b-form-group label="Início">
                <date-picker v-model="item.date_start" :config="dateOptions" name="date_start" v-validate="'required'" :state="validateState('date_end')" ></date-picker>
                <b-form-invalid-feedback>
                  {{ errors.first('date_start') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Fim">
                <date-picker v-model="item.date_end" :config="dateOptions" name="date_end" v-validate="'required'" :state="validateState('date_end')" ></date-picker>
                <b-form-invalid-feedback>
                  {{ errors.first('date_end') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'excluded-operators.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>
            {{ item }}
          </pre>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
export default {
  name: 'ExcludedOperatorsEdit',
  props: ['id'],
  components: {},
  data() {
    return {
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        dealer: {
          data: {
            name: '',
            id: null
          }
        },
        operator: {
          data: {
            name: '',
            id: null
          }
        },
        excluded: 0,
        ym: 0,
      },
      dateOptions: {
        format: 'YYYY-MM-DD'
      }
    }
  },
  methods: {
    selectOperator(e) {
      if(e.item) {
        this.item.operator_id = e.item.id
        this.item.operator.data = e.item
        this.item.nif = e.item.nif
        this.item.codle = e.item.codle
      } else {
        this.item.operator_id = null
        this.item.operator.data = {id: null, name:null},
        this.item.nif = ''
        this.item.codle = ''
      }
    },
    selectDealer(e) {
      if(e.item) {
        this.item.dealer_id = e.item.id
        this.item.dealer.data = e.item
      } else {
        this.item.dealer_id = null
        this.item.dealer.data = {id: null, name:null}
      }
    },
    selectProdaggreg(e) {
      console.log(e)
      this.item.prodaggreg_id = e.item.id
      this.item.prodaggreg.data = e.item
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('inpar/excluded' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'excluded-operators.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('inpar/excluded', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'excluded-operators.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('inpar/excluded' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.dealer_id) {
            this.item.dealer = {
              data: {
                id: null,
                name: null,
              }
            }
          }
          if(!this.item.operator_id) {
            this.item.operator = {
              data: {
                id: null,
                name: null,
              }
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'excluded-operators.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
